var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sorting-options-grid"},_vm._l((_vm.options),function(option){return _c('FilterRadioButton',{key:option.name,attrs:{"label":option.label,"name":"orderBy","value":option.value,"checked":option.value === _vm.currentValue},on:{"filter-radio-changed":_vm.onFilterRadioChanged}})}),1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0c1b291f","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Synonym/SynonymFilter/OrderOptions/OrderOptions.vue
// module id = null
// module chunks = 